import { useMemo, useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { SortOrder, listFiltersService, ListTableSort } from "sprint-common-web";

import { EncodeSpecificationType } from "../context/EncodeSpecificationItem";

export interface EncodeSpecificationListingFilters {
    page: number;
    pageSize: number;
    sortBy: string;
    sortOrder: SortOrder;
    name: string;
    type?: EncodeSpecificationType;
}

const defaultFilters: EncodeSpecificationListingFilters = {
    page: 1,
    pageSize: 50,
    sortBy: "updatedDate",
    sortOrder: "desc",
    name: "",
    type: undefined
};

export const useEncodeSpecificationListingFilters = () => {
    const filtersService = useMemo(() => listFiltersService<EncodeSpecificationListingFilters>(defaultFilters), []);
    const location = useLocation();
    const history = useHistory();

    const [filters, setFilters] = useState<EncodeSpecificationListingFilters>(() =>
        filtersService.getSavedFilters(location.search)
    );

    useEffect(() => {
        filtersService.saveFilters(location.pathname, history, filters);
    }, [filters]);

    const setSort = ({ by: sortBy, order: sortOrder }: ListTableSort) => {
        setFilters((prevFilters: EncodeSpecificationListingFilters) => ({
            ...prevFilters,
            sortBy,
            sortOrder,
            page: 1
        }));
    };

    const setPage = (page: number) => {
        setFilters((prevFilters: EncodeSpecificationListingFilters) => ({ ...prevFilters, page }));
    };

    const setPageSize = (pageSize: number): void => {
        setFilters((prevFilters: EncodeSpecificationListingFilters) => ({ ...prevFilters, pageSize, page: 1 }));
    };

    const setName = (name: string): void => {
        setFilters((prevFilters: EncodeSpecificationListingFilters) => ({ ...prevFilters, name, page: 1 }));
    };

    const setType = (type: EncodeSpecificationType): void => {
        setFilters((prevFilters: EncodeSpecificationListingFilters) => ({ ...prevFilters, type, page: 1 }));
    };

    const clearFilters = (): void => {
        setFilters(defaultFilters);
    };

    return {
        filters,
        setName,
        setType,
        setSort,
        setPage,
        setPageSize,
        clearFilters
    };
};
